(() => {
  function initializeAccordions(root) {
    root.querySelectorAll('.syn-acc2').forEach((wrap) => {
      if (wrap.dataset.initialized) return;
      wrap.dataset.initialized = 'true';
      wrap.querySelectorAll('[data-acc]').forEach((item) => {
        const button = item.querySelector('.acc-head');
        const panel = item.querySelector('.acc-panel');
        button.addEventListener('click', () => {
          const opening = button.getAttribute('aria-expanded') !== 'true';
          if (panel.animationFrame) cancelAnimationFrame(panel.animationFrame);
          panel.style.maxHeight = panel.getBoundingClientRect().height + 'px';
          item.classList.toggle('is-open', opening);
          button.setAttribute('aria-expanded', String(opening));
          panel.setAttribute('aria-hidden', String(!opening));
          panel.inert = !opening;
          panel.animationFrame = requestAnimationFrame(() => {
            panel.style.maxHeight = opening ? panel.scrollHeight + 'px' : '0px';
          });
        });
      });
      const observer = new ResizeObserver((entries) => {
        entries.forEach(({ target }) => {
          const panel = target.parentElement;
          if (panel.getAttribute('aria-hidden') === 'false') {
            panel.style.maxHeight = target.offsetHeight + 'px';
          }
        });
      });
      wrap.querySelectorAll('.acc-body').forEach((body) => observer.observe(body));
      wrap.factsResizeObserver = observer;
    });
  }
  if (!window.synfulProductDetailsInitialized) {
    window.synfulProductDetailsInitialized = true;
    document.addEventListener('shopify:section:load', (event) => initializeAccordions(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      event.target.querySelectorAll('.syn-acc2').forEach((wrap) => {
        wrap.factsResizeObserver?.disconnect();
        wrap.querySelectorAll('.acc-panel').forEach((panel) => cancelAnimationFrame(panel.animationFrame));
      });
    });
  }
  initializeAccordions(document);
})();
